//@flow
import React, { useEffect, useCallback } from "react";
import { connect } from "react-redux";
import Moment from "moment";
import { type ErrosSelecao, FORMATO_DATA_BANCO } from "../../../../model";
import {
  type State,
  type ActionCreator,
  type IdiomaUsuario,
  i18n,
  getDataBaseDefault,
  getDataBaseMaxima,
  getDataBaseSelecionada,
  selecionarDataBase,
  selecionarDataBaseDefault,
  getDiasUteis,
  isFechamentoDeMesSelecionado,
  getIdiomaUsuario,
} from "../../../../state";

import { DateCalendarPicker } from "../../../comum";

type Props = {
  dataBaseSelecionada: ?Date,
  selecionarDataBase: ActionCreator,
  selecionarDataBaseDefault: ActionCreator,
  dataBaseDefault: string,
  dataBaseMaxima: string,
  inputProps: any,
  isFechamentoDeMesSelecionado: boolean,
  idiomaUsuario: IdiomaUsuario,
};

function SelecaoDataBase({
  dataBaseSelecionada,
  selecionarDataBase,
  selecionarDataBaseDefault,
  dataBaseDefault,
  dataBaseMaxima,
  inputProps,
  isFechamentoDeMesSelecionado,
  idiomaUsuario,
  ...props
}: Props) {
  useEffect(() => {
    if (!dataBaseSelecionada) {
      selecionarDataBaseDefault();
    }
  }, [dataBaseSelecionada, selecionarDataBaseDefault]);

  const validaData = useCallback(
    dataASerValidada => {
      const data = Moment(dataASerValidada, "DD/MM/YYYY", true);
      return (
        data.isSameOrAfter(Moment("19970101", FORMATO_DATA_BANCO)) &&
        data.isSameOrBefore(Moment(dataBaseMaxima, FORMATO_DATA_BANCO))
      );
    },
    [dataBaseMaxima]
  );

  const onDataChange = useCallback(data => selecionarDataBase(data), [
    selecionarDataBase,
  ]);

  return (
    <div>
      <DateCalendarPicker
        inputProps={inputProps}
        label={""}
        value={dataBaseSelecionada}
        onChange={onDataChange}
        closeOnSelect={true}
        strictParsing={true}
        isValidDate={validaData}
        locale={idiomaUsuario}
        disabled={isFechamentoDeMesSelecionado}
        {...props}
      />
    </div>
  );
}

export const validacaoSelecaoDataBase = function(state: State): ?ErrosSelecao {
  const diasUteis: Array<string> = getDiasUteis(state);
  const dataBaseSelecionada: ?Moment = getDataBaseSelecionada(state);
  const { translate } = i18n(state);

  if (!Moment.isMoment(dataBaseSelecionada)) {
    return {
      selecaoDataBase: translate("configuracaoRelatorio.erroDataBaseInvalida"),
    };
  } else if (
    dataBaseSelecionada &&
    !diasUteis.includes(dataBaseSelecionada.format(FORMATO_DATA_BANCO))
  ) {
    return {
      selecaoDataBase: translate("configuracaoRelatorio.erroDataBaseDiaUtil"),
    };
  }

  return null;
};

export default connect(
  (state: State, props: Props) => ({
    dataBaseSelecionada: getDataBaseSelecionada(state),
    dataBaseDefault: getDataBaseDefault(state),
    dataBaseMaxima: getDataBaseMaxima(state),
    inputProps: props.inputProps,
    isFechamentoDeMesSelecionado: isFechamentoDeMesSelecionado(state),
    idiomaUsuario: getIdiomaUsuario(state),
  }),
  {
    selecionarDataBase,
    selecionarDataBaseDefault,
  }
)(SelecaoDataBase);
